export const SMALL_BREAKPOINT = 640 // 40rem
export const MEDIUM_BREAKPOINT = 1088 // 68rem
